export const countryConfigMD = {
  home: {
    skeleton: {
      banner: false,
      bubbles: false,
      featuredProducts: false,
      services: false,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  }
};
